"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledFileUploader = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _commonElements = require("../utils/commonElements");

var _helpers = require("../utils/helpers");

var _CalciteThemeProvider = require("../CalciteThemeProvider");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Copyright 2019 Esri
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
// http://www.apache.org/licenses/LICENSE-2.0
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.​
var StyledFileUploader = (0, _styledComponents.default)(_commonElements.CalciteInput).withConfig({
  displayName: "StyledFileUploader",
  componentId: "sc-18ztbs2-0"
})(["height:auto;&:active{border-color:", ";box-shadow:inset 0 1px 2px rgba(0,0,0,0.075),0 0 5px rgba(81,167,232,0.5);}@supports (-moz-appearance:none){padding:", " ", ";}&::-webkit-file-upload-button{position:relative;display:inline-block;padding:0.2325rem 0.675rem;width:auto;color:", ";background:", ";border:1px solid ", ";border-radius:", ";box-sizing:border-box;transition:all 0.15s ease-in-out;cursor:pointer;white-space:nowrap;", ";letter-spacing:0em;font-family:inherit;&:hover{text-decoration:none;color:", ";background:", ";border-color:", ";}font-family:inherit;margin:0.5em 0;-webkit-appearance:none;}::-ms-value{border:none;background-color:transparent;}::-ms-browse{position:relative;display:inline-block;padding:0.2325rem 0.675rem;width:auto;color:", ";background:", ";border:1px solid ", ";border-radius:", ";box-sizing:border-box;transition:all 0.15s ease-in-out;cursor:pointer;white-space:nowrap;", ";letter-spacing:0em;font-family:inherit;&:hover{text-decoration:none;color:", ";background:", ";border-color:", ";}font-family:inherit;margin:0.5em 0;}"], function (props) {
  return props.theme.palette.blue;
}, function (props) {
  return (0, _helpers.unitCalc)(props.theme.baseline, 2, '/');
}, function (props) {
  return (0, _helpers.unitCalc)(props.theme.baseline, 4, '/');
}, function (props) {
  return props.theme.palette.blue;
}, function (props) {
  return props.theme.palette.white;
}, function (props) {
  return props.theme.palette.blue;
}, function (props) {
  return props.theme.borderRadius;
}, (0, _helpers.fontSize)(-2), function (props) {
  return props.theme.palette.white;
}, function (props) {
  return props.theme.palette.darkBlue;
}, function (props) {
  return props.theme.palette.darkBlue;
}, function (props) {
  return props.theme.palette.blue;
}, function (props) {
  return props.theme.palette.white;
}, function (props) {
  return props.theme.palette.blue;
}, function (props) {
  return props.theme.borderRadius;
}, (0, _helpers.fontSize)(-2), function (props) {
  return props.theme.palette.white;
}, function (props) {
  return props.theme.palette.darkBlue;
}, function (props) {
  return props.theme.palette.darkBlue;
});
exports.StyledFileUploader = StyledFileUploader;
StyledFileUploader.defaultProps = {
  theme: _CalciteThemeProvider.CalciteTheme
};